import { ApplicationStore } from '../states'

export const updateIsRefreshTransactions: (state: ApplicationStore, payload: boolean) => ApplicationStore = (
  state,
  payload,
) => {
  return {
    ...state,
    isRefreshTransactions: payload,
  }
}

export const removeIsRefreshTransactions: (state: ApplicationStore) => ApplicationStore = (state) => {
  const newState: ApplicationStore = JSON.parse(JSON.stringify(state))

  delete newState.isRefreshTransactions
  return {
    ...newState,
  }
}
